<template>
  <div class="box" v-loading="loading">
    <div v-for="item in tableData" :key="item.contractNo" style="page-break-after: always">
      <div class="print-table">
        <table style="width: 100%; border-color: #000" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <th colspan="14" style="font-size: 30px">{{ item.createCompanyName }}</th>
          </tr>
          <tr>
            <th colspan="2">客户名称</th>
            <td colspan="5">{{ item.customerName }}</td>
            <th colspan="2">合同编号</th>
            <td colspan="3">{{ item.contractNo }}</td>
            <th colspan="1">金额单位</th>
            <td colspan="1">（元）</td>
          </tr>
          <tr>
            <th width="15%">租赁空间</th>
            <th>应收账期</th>
            <th>收费项目</th>
            <th>期初读数</th>
            <th>期末读数</th>
            <th>本期耗用</th>
            <th>结算数量</th>
            <th>单价</th>
            <th>金额</th>
            <th>期初未收数</th>
            <th>本期应收数</th>
            <th>累计应收数</th>
            <th>本期已收数</th>
            <th>期末未收数</th>
          </tr>
          <tr v-for="(i, index) in item.tableList" :key="index">
            <td width="15%">{{ i.spaceAssetName }}</td>
            <td>{{ i.accountPeriod }}</td>
            <td>{{ i.expenseTypeName }}</td>
            <td>{{ i.periodStartRead }}</td>
            <td>{{ i.periodEndRead }}</td>
            <td>{{ i.totalDosage }}</td>
            <td>{{ i.settlementQuantity }}</td>
            <td>{{ i.originalPrice }}</td>
            <td>{{ i.price }}</td>
            <td>{{ i.beginPeriodNotReceived }}</td>
            <td>{{ i.currentReceivables }}</td>
            <td>{{ i.totalReceivables }}</td>
            <td>{{ i.currentReceived }}</td>
            <td>{{ i.finalNotReceived }}</td>
          </tr>
          <tr>
            <th colspan="8">合计</th>
            <th>{{ item.priceCount }}</th>
            <th>{{ item.beginPeriodNotReceivedCount }}</th>
            <th>{{ item.currentReceivablesCount }}</th>
            <th>{{ item.totalReceivablesCount }}</th>
            <th>{{ item.currentReceivedCount }}</th>
            <th>{{ item.finalNotReceivedCount }}</th>
          </tr>
          <tr>
            <th colspan="3">{{ item.companyName }}</th>
            <th colspan="5">{{ item.branchName }}</th>
            <th colspan="6">{{ item.bankAccountNum }}</th>
          </tr>
          <tr>
            <td colspan="14" align="left">{{ item.printDesc || '无' }}</td>
          </tr>
          <tr>
            <th colspan="2">制单日期</th>
            <td colspan="5">{{ item.printDate }}</td>
            <th colspan="2">制单人</th>
            <td colspan="5">{{ item.printName }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import DEPOSITAPI from '@/api/reportManagement';
  import ReportMixin from './mixins/reportMixin';
  export default {
    mixins: [ReportMixin],
    data() {
      return {
        tableData: [],
        loading: true,
      };
    },
    created() {
      let params = this.$route.query;
      this.printList(params);
    },
    methods: {
      async printList(objData) {
        let params = {
          access_token: objData.access_token,
          params: JSON.parse(objData.params),
        };
        this.loading = true;
        const { data } = await this.$axios.post(
          `${DEPOSITAPI.EXPORT_PRINT}?access_token=${params.access_token}`,
          params.params
        );
        if (data.code == 0) {
          let list = data.data;
          this.tableData = [];
          list.forEach((item) => {
            console.log(item, params.params, 'shu');
            let arr = [];
            arr.push(item);
            let tableList = this.tableStructure(arr);
            let obj = {
              printDate: item.printDate,
              printName: item.printName,
              printDesc: item.printDesc,
              contractNo: item.contractNo,
              customerName: item.customerName,
              tableList: tableList,
              createCompanyName: params.params.createCompanyName,
              branchName: params.params.branchName,
              bankAccountNum: params.params.bankAccountNum,
              companyName: params.params.companyName,
              beginPeriodNotReceivedCount: item.beginPeriodNotReceivedCount,
              currentReceivablesCount: item.currentReceivablesCount,
              currentReceivedCount: item.currentReceivedCount,
              finalNotReceivedCount: item.finalNotReceivedCount,
              priceCount: item.priceCount,
              totalReceivablesCount: item.totalReceivablesCount,
            };
            this.tableData.push(obj);
          });
          setTimeout(() => {
            this.print();
          }, 1500);
          this.loading = false;
        }
      },
      print() {
        window.print();
        window.close();
      },
    },
  };
</script>
<style>
  body {
    height: auto;
  }
</style>

<style scoped lang="scss">
  body,
  .box {
    height: auto !important;
    box-sizing: border-box;
    text-align: center;
    margin: 0 auto;
    font-size: 14px;
  }

  @media print {
    @page {
      size: auto A4 landscape;
      margin: 3mm auto;
      text-align: center;
    }

    table {
      border-collapse: collapse !important;
    }

    tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }

    td {
      page-break-inside: avoid;
      page-break-after: auto;
    }

    thead {
      display: table-header-group;
    }

    tfoot {
      display: table-footer-group;
    }

    .print-table {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    html {
      overflow: visible;
    }
  }
</style>
